// extracted by mini-css-extract-plugin
module.exports = {"stage":"banner_stage__ukf_b","hotspot":"banner_hotspot__RLa5d","join":"banner_join__qX08b","shop":"banner_shop__vPVFo"};